import { fetchFactory } from 'isotope-client'

export const getRenegotiationMatrix = (countryId: string) => fetchFactory(`/countries/${countryId}/renegotiation`)

export const updateRenegotiationTip = (countryId: string, price: number, risk: number, value: string) =>
	fetchFactory(`/countries/${countryId}/renegotiation/update`, {
		method: 'POST',
		body: JSON.stringify({ price: price, risk: risk, value: value })
	})